import React, { useState } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AddRowTable from '../../Components/Table/AddRowTable';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Layout,
    Col, 
    Row,
    Button,
    // Modal,
    Checkbox,
    Upload,
    Form,
    Select,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    Space,
    Modal,
    // AutoComplete
    Switch,
    Table,
} from 'antd'
import { 
    ExclamationCircleFilled, 
    InboxOutlined,
    DeleteOutlined 
} from '@ant-design/icons';
import { ProductOutlined } from '@ant-design/icons';
// import { formatYMD } from '../../Utils/Common';
import { useNavigate, useParams } from 'react-router-dom';
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatDate } from '../../Utils/Common';
import { SeeAttachment } from '../../Components/SeeAttachment';
// import { formatDate } from '../../Utils/Common';

// const { Search } = Input;
const { confirm } = Modal;
const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const RenewContracts = () => {
    const [editTenantForm] = Form.useForm();
    const { type, id } = useParams();
    const navigate = useNavigate()
    const [isManage, setIsManage] = useState(false);
    const [manageType, setManageType] = useState(true);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [newAttachment, setNewAttachment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [propertyId, setPropertyId] = useState('')
    const [leaseTerm, setLeaseTerm] = useState('')
    const [leaseType, setLeaseType] = useState('year')
    const [contractDate, setContractDate] = useState([])
    // const [startContractData, setStartContractDate] = useState('')
    const [endContractData, setEndContractDate] = useState('')
    const [authorizedSignatories, setAuthorizedSignatories] = useState([]);
    const [authorizedRepresentative, setAuthorizedRepresentative] = useState([]);
    const [propertyData, setPropertyData] = useState([])
    const [rentalData, setRentalData] = useState([])
    const [tenantData, setTenantData] = useState([])
    const [withParking, setWithParking] = useState(false)
    const [parkingRow, setParkingRow] = useState([
        {
            property_id: '',
            parking_unit_ids: '',
            parking_rental_rates: ''
        }
    ]);
    // const [options, setOptions] = useState([])
    const [renterId, setRenterId] = useState('')
    const [propertyParkingData, setPropertyParkingData] = useState([])
    
    const renew_form = {
        unit: {
            path: '/expense',
            tenant_id: {tenant_id: id},
            navkey: '/expenses_nav',
            create: 'expenses/create',
            update: 'expenses/update',
            tenant_get: 'tenants/get',
            owner_get: 'owners/get',
            get: 'expenses/get',
            cancel: '/tenant',
            header: 'RENEW RENTER CONTRACT',
        },
        parking: {
            path: '/parking-expense',
            navkey: '/parking_expenses_nav',
            tenant_id: {tenant_parking_id: id},
            create: 'parking_expenses/create',
            update: 'parking_expenses/update',
            tenant_get: 'tenant_parkings/get',
            owner_get: 'owners/get_with_parking_unit',
            get: 'parking_expenses/get',
            cancel: '/parking-contract',
            header: 'RENEW PARKING CONTRACT',
        }
    };

    const { 
        callPost, 
        data, 
        loading 
    } = usePostRequest(()=>{
        editTenantForm.resetFields();
    });
    
    React.useEffect(() => {
        fetchTenantDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (data) {
            if(type === 'unit'){
                navigate('/tenant');
            } else {
                navigate('/parking-contract');
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    // React.useEffect(() => {
    //     fetchPropertyData();
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    React.useEffect(() => {
        if(type === 'unit'){
            fetchRentalData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    React.useEffect(() => {
        fetchTenantData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    React.useEffect(() => {
        fetchPropertyParkingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleParkingUnit = (e, recordKey, fieldName) => {
        const updatedDataSource = parkingRow.map((item, index) => {
            if (index === recordKey) {
                if(fieldName === 'property_id'){
                    const parking_data = propertyParkingData.filter(data => data.id === e);
                    return { ...item, parking_list: parking_data[0].parking_units, [fieldName]: e, parking_unit_ids: '' };
                } else if(fieldName === 'parking_unit_ids'){
                    return { ...item, [fieldName]: e };
                } else {
                    return { ...item, [fieldName]: e };
                }
            }
            return item;
        });
        setParkingRow(updatedDataSource);
    };

    const handleAddRow = () => {
        const newRow = {
            property_id: '',
            parking_unit_ids: '',
            parking_rental_rates: ''
        };

        setParkingRow(prev => [...prev, newRow]);
    };
    
    const handleDeleteRow = (rowId) => {
        const newData = [...parkingRow];
        newData.splice(rowId, 1); 
        setParkingRow(() => newData)
    };

    async function fetchPropertyParkingData() {

        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
            setPropertyParkingData(response?.data?.data);
        } else {
            setPropertyParkingData([])
        }
    
    }

    const handleProperty = (e) => {
        setPropertyId(e)
    }

    const handleRentalUnit = (rental_id) => {
        const rent = rentalData.filter((item) => item.id === rental_id);
        if(rent[0]?.pricing_type === "unit"){
            editTenantForm.setFieldsValue({
                space_rental_rate: rent[0].unit_price
            });
        }
    }

    // async function fetchPropertyData() {

    //     const response = await UseGetRequest("properties/get_for_contract", {property_id: ''});
    //     if (response?.data) {
    //       setPropertyData(response?.data?.data);
    //     } else {
    //       setPropertyData([])
    //     }
    
    // }

    async function fetchParkingUnit() {
        try {
            const response = await UseGetRequest("parking_units/get", { property_id: '' });
            return response.data.data;
        } catch (error) {
            return []; // Return an empty array on error to avoid breaking the code.
        }
    }

    const fileUrlFormat = (files) => {
        if(files){
          return files?.map(file => ({
            uid: file.id,
            id: file.id,
            name: file.file_name,
            status: "done",
            url: file.file_url,
            fileType: file.file_type
          }));
        }
    };

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    async function fetchTenantData() {
        setIsLoading(true)
        const response = await UseGetRequest(renew_form[type].tenant_get, renew_form[type].tenant_id);
        if (response?.data) {
            const tenant_data = response?.data?.data[0]
            setRenterId(tenant_data?.renter_id)
            setAuthorizedSignatories(tenant_data?.signatories);    
            setAuthorizedRepresentative(tenant_data?.representatives);   
            let attachment = tenant_data?.attachments?.map((file) => ({
                ...file,
                link: (
                  <SeeAttachment
                    attachments={[
                      { file_url: file.file_url, file_name: file.file_name },
                    ]}
                  />
                ),
            })) 

            const parking_list = await fetchParkingUnit();

            let parking_details = []
            if(type === 'unit'){
                parking_details = tenant_data?.tenant_parkings?.map((file) => ({
                    ...file,
                    property_id: file.property_id,
                    parking_unit_ids: file.parking_unit_id,
                    parking_rental_rates: file.parking_rental_rate,
                    parking_list: parking_list || [],
                    is_managed: file.is_managed === '1' ? true : false,
                    manage_type: file.manage_type === 'percentage' ? true : false,
                })) 
            } else {
                parking_details = tenant_data?.details?.map((file) => ({
                    ...file,
                    property_id: file.property_id,
                    parking_unit_ids: file.parking_unit_id,
                    parking_rental_rates: file.parking_rental_rate,
                    parking_list: parking_list || [],
                    is_managed: file.is_managed === '1' ? true : false,
                    manage_type: file.manage_type === 'percentage' ? true : false,
                })) 
            }

            setParkingRow(parking_details)
            setAttachmentsData(fileUrlFormat(tenant_data?.attachments))
            setNewAttachment(attachment)
            editTenantForm.setFieldsValue({
                alfresco_rental_rate: tenant_data.alfresco_rental_rate,
                require_or: tenant_data.require_or === "1" ? true : false,
                business_address: tenant_data.business_address,
                business_name: tenant_data.business_name,
                business_nature: tenant_data.business_nature,
                contact_no: tenant_data.contact_no,
                contract_date: [
                    dayjs(tenant_data.contract_end_date).add(1, 'day'),
                    dayjs(tenant_data.contract_end_date).add(tenant_data.lease_term, tenant_data.lease_type),
                ],
                cusa_rental_rate: tenant_data.cusa_rental_rate,
                lease_term: tenant_data.lease_term,
                lease_type: tenant_data.lease_type,
                property: tenant_data.property_name,
                remarks: tenant_data.remarks,
                rental_unit_id: tenant_data.rental_unit_id,
                renter_email: tenant_data.renter_email,
                space_rental_rate: tenant_data.space_rental_rate,
                start_date: tenant_data.contract_end_date ? dayjs(tenant_data.contract_end_date, 'YYYY/MM/DD').add(1, 'day') : undefined,
                tin: tenant_data.tin,
                trade_name: tenant_data.trade_name,
                with_parking: tenant_data.with_parking === "1",
                management_fee: tenant_data.management_fee,
            });
            setIsManage(tenant_data.is_managed === '1' ? true : false)
            setManageType(tenant_data.manage_type)
            setLeaseTerm(tenant_data.lease_term)
            setLeaseType(tenant_data.lease_type)
            // setStartContractDate(tenant_data.contract_sign_date)
            setEndContractDate(dayjs(tenant_data.contract_end_date).add(1, 'day'))
            setWithParking(tenant_data.with_parking === "1")
        }
        setIsLoading(false)
    }

    async function fetchTenantDropdown() {

        const response = await UseGetRequest("tenants/get_active_renter");
        if (response?.data) {
          setTenantData(response?.data?.data);
        } else {
          setTenantData([])
        }
    
    }

    async function fetchRentalData() {

        const response = await UseGetRequest("rental_units/get", {property_id: propertyId});
        if (response?.data) {
          setRentalData(response?.data?.data);
        } else {
          setRentalData([])
        }
    
    }

    const handleRenewTenant = () => {
        editTenantForm.validateFields().then(values => {
            const resetData = {
                tenant_id: id,
                alfresco_rental_rate: values.alfresco_rental_rate || '',
                require_or: values.require_or === true ? '1' : '0',
                with_parking: values.with_parking === true ? '1' : '0',
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                contract_sign_date: values.contract_date[0].format("YYYY-MM-DD") || '',
                contract_end_date: values.contract_date[1].format("YYYY-MM-DD") || '',
                cusa_rental_rate: values.cusa_rental_rate || '',
                lease_type: values.lease_type || '',
                lease_term: values.lease_term || '',
                property: values.property || '',
                remarks: values.remarks || '',
                rental_unit_id: values.rental_unit_id || '',
                renter_email: values.renter_email || '',
                space_rental_rate: values.space_rental_rate || '',
                start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
                // agent_fee: values.agent_fee || '',
                is_managed: isManage
            };

            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });

            if (renterId) {
                resetData.renter_id = renterId;
            }         

            if (isManage) {
                resetData.management_fee = values.management_fee || '';
                resetData.manage_type = manageType ? "percentage" : "fixed";
            }            

            resetData.parking_unit_ids = parkingRow.map((data)=> data.parking_unit_ids)
            resetData.parking_rental_rates = parkingRow.map((data)=> data.parking_rental_rates)
            resetData.parking_is_managed = parkingRow.map((data)=> data.is_managed)
            resetData.parking_management_fees = parkingRow.map((data)=> data.is_managed ? data.management_fee : '')
            // resetData.parking_agent_fees = parkingRow.map((data)=> data.agent_fee)
            resetData.parking_manage_types = parkingRow.map((data)=> data.is_managed ? data.manage_type ? 'percentage' : 'fixed' : '')
            
            resetData.signatory_name = authorizedSignatories.map((item)=>item.signatory_name || "")
            resetData.signatory_position = authorizedSignatories.map((item)=>item.signatory_position || "")

            resetData.representative_name = authorizedRepresentative.map((item)=>item.representative_name || "")
            resetData.representative_position = authorizedRepresentative.map((item)=>item.representative_position || "")
            resetData.representative_email = authorizedRepresentative.map((item)=>item.representative_email || "")
            resetData.representative_contact_no = authorizedRepresentative.map((item)=>item.representative_contact_no || "")

            // const file = values.attachments.map((file) => {
            //     return file.originFileObj;
            // });
            var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
                key,
                value,
            }));


            callPost(
                "tenants/renew", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };


    const handleRenewParking = () => {
        editTenantForm.validateFields().then(values => {
            const resetData = {
                tenant_parking_id: id,
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                contract_sign_date: values.contract_date[0].format("YYYY-MM-DD") || '',
                contract_end_date: values.contract_date[1].format("YYYY-MM-DD") || '',
                lease_type: values.lease_type || '',
                lease_term: values.lease_term || '',
                remarks: values.remarks || '',
                rental_unit_id: values.rental_unit_id || '',
                renter_email: values.renter_email || '',
                space_rental_rate: values.space_rental_rate || '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
            };

            resetData.parking_unit_ids = parkingRow.map((data)=> data.parking_unit_ids)
            resetData.parking_rental_rates = parkingRow.map((data)=> data.parking_rental_rates)
            resetData.parking_is_managed = parkingRow.map((data)=> data.is_managed)
            resetData.parking_management_fees = parkingRow.map((data)=> data.is_managed ? data.management_fee : '')
            // resetData.parking_agent_fees = parkingRow.map((data)=> data.agent_fee)
            resetData.parking_manage_types = parkingRow.map((data)=> data.is_managed ? data.manage_type ? 'percentage' : 'fixed' : '')

            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });

            if (renterId) {
                resetData.renter_id = renterId;
            }            

            resetData.parking_unit_ids = parkingRow.map((data)=> data.parking_unit_ids)
            resetData.parking_rental_rates = parkingRow.map((data)=> data.parking_rental_rates)
           
            var finalValues = Object.entries({
                ...resetData, 
                attachments: file
            }).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "tenant_parkings/renew", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed:', errorInfo);
        });
    };

    const handleDeleteAttachment = (file) => {
        const updatedAttachments = attachmentsData.filter(item => item !== file);
        setAttachmentsData(updatedAttachments);
    };

    const normFile = (e) => {

        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
        
    };

    // const validateContactNumber = (_, value) => {
    //     if (!value) {
    //       return Promise.resolve();
    //     }
    
    //     const isNumber = /^\d+$/.test(value);
    //     if (!isNumber) {
    //       return Promise.reject('Invalid Contact Number');
    //     }
    //     return Promise.resolve();
    // };

    const onLeaseChange = (value) => {
        if (value) {
            setLeaseTerm(value)
            editTenantForm.setFieldsValue({
                contract_date: [
                    dayjs(endContractData, 'YYYY/MM/DD'),
                    dayjs(endContractData, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
                ]
            });
            setContractDate([
                dayjs(endContractData, 'YYYY/MM/DD'),
                dayjs(endContractData, 'YYYY/MM/DD').add(value, leaseType).subtract(1, 'day')
            ])
        }
    }
   
    const onLeaseType = (value) => {
        if (value) {
            setLeaseType(value)
            const currentDate = new Date().toISOString().split('T')[0];
            if(leaseType === "month"){
                editTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(currentDate, 'YYYY/MM/DD'),
                        dayjs(currentDate, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm, value)
                    ]
                });
                setContractDate([
                    dayjs(currentDate, 'YYYY/MM/DD'),
                    dayjs(currentDate, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm, value)
                ])
            } else {
                editTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(currentDate, 'YYYY/MM/DD'),
                        dayjs(currentDate, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm, value)
                    ]
                });
                setContractDate([
                    dayjs(currentDate, 'YYYY/MM/DD'),
                        dayjs(currentDate, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm, value)
                ])
            }
        }
    }

    const columns2 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatDate(amount),
        },
        {
          title: 'Attachments',
          dataIndex: 'link',
          key: 'link',
        },
    ];  

    const handleRangeChange = (dates) => {
        if (dates && dates.length > 0) {
            editTenantForm.setFieldsValue({
                contract_date: [
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').add(leaseTerm, 'year')
                ]
            });
            setContractDate(dates)
        }
    };

    const handleCreateRenew = () => {
        if(type === 'unit'){
            handleRenewTenant();
        } else {
            handleRenewParking();
        }
    };

    const showSaveConfirm = () => {
        confirm({
          title: 'Are you sure you want to renew the changes?',
          icon: <ExclamationCircleFilled style={{ color: 'yellow' }}/>,
        //   content: `Lease Term: ${leaseTerm} , Contract Date: ${formatDate(contractDate[0].format("YYYY-MM-DD"))} - ${formatDate(contractDate[1].format("YYYY-MM-DD"))}`,
        //   content: (
        //     <div>
        //       <div>Lease Term: {leaseTerm}</div>
        //       <div>Contract Date: {formatDate(contractDate[0].format("YYYY-MM-DD"))} - {formatDate(contractDate[1].format("YYYY-MM-DD"))}</div>
        //     </div>
        //   ),
          okText: 'Yes',
        //   okType: 'danger',
          cancelText: 'No',
          className: 'custom-modal',
          confirmLoading: loading,
          onOk() {
            handleCreateRenew()
          },
        });
    };
    // const fetchOptions = (value) => {
    //     const data = tenantData
    //     return data
    //       .filter(item => item.trade_name.toLowerCase().includes(value.toLowerCase()))
    //       .map(item => ({ value: item.trade_name }));
    // };
    // const handleRenter = (value) => {
    //     const item = tenantData.find(option => option.trade_name === value);
    //     setRenterId(item.renter_id);
    // };

    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        {renew_form[type].header}
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-3'>
                        <Form form={editTenantForm} initialValues={{ lease_type: leaseType }} layout="vertical" scrollToFirstError={true}>
                            <Divider className='divider-text'>Renter Information</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Name"
                                        name="trade_name"
                                    >
                                       {/* <AutoComplete
                                        options={options}
                                        onSearch={handleSearch}
                                        onSelect={handleRenter}
                                        placeholder="Type to search"
                                        > */}
                                            <Input disabled/>
                                        {/* </AutoComplete> */}
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Name"
                                        name="business_name"
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Address"
                                        name="business_address"
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="TIN Number"
                                        name="tin"
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Renter Email"
                                        name="renter_email"
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Contact Number"
                                        name="contact_no"
                                    >
                                        <Input/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={12}>
                                    <Item
                                        label="Nature of Renter"
                                        name="business_nature"
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text mt-5'>Contract Detail</Divider>
                            {
                                type === 'unit' && (
                                    <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                        <Col span={7}>
                                            <Item
                                                label="Property"
                                                name="property"
                                            >
                                                <Select disabled placeholder="Select a property" onChange={(e) => handleProperty(e)}>
                                                    {propertyData.map((option) => (
                                                        <Option key={option.id} value={option.id}>{option.name}</Option>
                                                    ))}
                                                </Select>
                                            </Item>
                                        </Col>
                                        <Col span={7}>
                                            <Item
                                                label="Rental Unit"
                                                name="rental_unit_id"
                                            >
                                                <Select disabled placeholder="Select a Rental Unit" onChange={(e) => handleRentalUnit(e)}>
                                                    {rentalData.map((option) => (
                                                        <Option key={option.id} value={option.id}>{option.unit_owner}</Option>
                                                    ))}
                                                </Select>
                                            </Item>
                                        </Col>
                                        <Col span={4} className='center pt-4'>
                                            <Item name="require_or" valuePropName="checked">
                                                <Checkbox disabled>OR Required upon Payment</Checkbox>
                                            </Item>
                                        </Col>
                                        <Col span={3} className='center pt-4'>
                                            <Item name="with_parking" valuePropName="checked" value={withParking} onChange={(e) => setWithParking(e.target.checked)}>
                                                <Checkbox disabled>With Parking</Checkbox>
                                            </Item>
                                        </Col>
                                        <Col span={3} className='center'>
                                            <Switch
                                                checked={isManage}
                                                checkedChildren="Manage"
                                                unCheckedChildren="Not Manage"
                                                size='medium'
                                                disabled
                                                // className='mt-2'
                                                style={{ backgroundColor: isManage ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                onChange={() => {
                                                    setIsManage(!isManage);
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                )
                            }
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Lease Type"
                                        name="lease_type"
                                    >
                                        <Select 
                                            placeholder="Select a Lease Type"
                                            onChange={(e) => onLeaseType(e)}
                                            defaultValue={leaseType} 
                                            disabled
                                        >
                                            {/* <Option key='daily' value='daily'>Daily</Option> */}
                                            <Option key='month' value='month'>Monthly</Option>
                                            <Option key='year' value='year'>Yearly</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Lease Term"
                                        name="lease_term"
                                        rules={[{ required: true, message: 'Please enter your Lease Term!' }]}
                                    >
                                        <InputNumber 
                                            style={{width:'100%'}}
                                            onChange={(e) => onLeaseChange(e)}
                                        />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item 
                                        name="contract_date"  
                                        label="Contract Date"
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            disabled
                                            onChange={handleRangeChange}
                                            allowClear={false}
                                        />
                                    </Form.Item>
                                </Col>
                                {
                                    type === 'unit' && (
                                        <Col span={8}>
                                            <Item
                                                label="Move In Date"
                                                name="start_date"
                                            >
                                                <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"/>
                                            </Item>
                                        </Col>
                                    )
                                }
                            </Row>
                            {
                                type === 'unit' && (
                                    <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                        <Col span={4}>
                                            <Item
                                                label="Space Rental Rate"
                                                name="space_rental_rate"
                                            >
                                                <Input disabled/>
                                            </Item>
                                        </Col>
                                        <Col span={4}>
                                            <Item
                                                label="Cusa Rental Rate"
                                                name="cusa_rental_rate"
                                            >
                                                <Input disabled/>
                                            </Item>
                                        </Col>
                                        <Col span={4}>
                                            <Item
                                                label="Alfresco Rental Rate"
                                                name="alfresco_rental_rate"
                                            >
                                                <Input disabled/>
                                            </Item>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                               ( type === 'unit' && isManage) &&
                                (
                                    <Row  className='responsive-inline responsive-width'>
                                        <Divider className='divider-text'>Rental Unit Fees</Divider>
                                        <Col span={8} className='p-2'>
                                            <Space>
                                            <Item
                                                label="Management Fee"
                                                name="management_fee"
                                            >
                                                <InputNumber
                                                    style={{width:'100%'}}
                                                    disabled
                                                />
                                            </Item>
                                            <Switch
                                                checked={manageType}
                                                checkedChildren="Percentage"
                                                unCheckedChildren="Fixed Price"
                                                size='medium'
                                                disabled
                                                // className='mt-2'
                                                style={{ backgroundColor: manageType ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                onChange={() => {
                                                    setManageType(!manageType);
                                                }}
                                            />
                                            </Space>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                (withParking || type === 'parking')  && (
                                    <>
                                        <Divider className='divider-text mt-5'>Parking Detail</Divider>
                                        {
                                            parkingRow.map((data, index) => (
                                                <div
                                                    className='parking-list'
                                                >
                                                    <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                                        <Col span={7}>
                                                            <div>
                                                                Property/Building
                                                            </div>
                                                            <Select 
                                                                disabled
                                                                style={{width:'100%'}}
                                                                placeholder="Select a property" 
                                                                value={data.property_id}
                                                                onChange={(e) => handleParkingUnit(e, index, 'property_id')}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {propertyParkingData?.map((option) => (
                                                                    <Option key={option.id} value={option.id}>{option.name}</Option>
                                                                ))}
                                                            </Select>
                                                        </Col>
                                                        <Col span={7}>
                                                            <div>
                                                                Parking Unit
                                                            </div>
                                                            <Select 
                                                                disabled
                                                                style={{width:'100%'}}
                                                                value={data.parking_unit_ids}
                                                                placeholder="Select a Parking Unit" 
                                                                onChange={(e) => handleParkingUnit(e, index, 'parking_unit_ids')}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {data.parking_list?.map((option) => (
                                                                    <Option key={option.id} value={option.id}>{option.name}</Option>
                                                                ))}
                                                            </Select>
                                                        </Col>
                                                        <Col span={4}>
                                                            <div>
                                                                Parking Rate
                                                            </div>
                                                            <InputNumber 
                                                                disabled
                                                                onChange={(e) => handleParkingUnit(e, index, 'parking_rental_rates')}
                                                                value={data.parking_rental_rates}
                                                                style={{width:'100%'}} 
                                                            />
                                                        </Col>
                                                        <Col span={4} className='center'>
                                                            <Switch
                                                                checked={data.is_managed}
                                                                checkedChildren="Manage"
                                                                unCheckedChildren="Not Manage"
                                                                size='medium'
                                                                disabled
                                                                style={{ backgroundColor: data.is_managed ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                                onChange={(e) => handleParkingUnit(e, index, 'is_managed')}
                                                            />
                                                        </Col>
                                                        <Col span={1} align='center'>
                                                            {
                                                                parkingRow.length > 1 && (
                                                                    <Button
                                                                        disabled
                                                                        icon={<DeleteOutlined />}
                                                                        onClick={() => handleDeleteRow(index)}
                                                                        type="link"
                                                                        size='large'
                                                                        danger
                                                                    />
                                                                )
                                                            }
                                                        </Col>
                                                    </Row>
                                                    {
                                                        data.is_managed &&
                                                        (
                                                            <Row  className='responsive-inline responsive-width mt-2 mb-4'>
                                                                <Col span={7}>
                                                                    <div>
                                                                        Management Fee
                                                                    </div>
                                                                    <Space>
                                                                        <InputNumber
                                                                            onChange={(e) => handleParkingUnit(e, index, 'management_fee')}
                                                                            value={data.management_fee}
                                                                            style={{width:'100%'}} 
                                                                            disabled
                                                                        />
                                                                        <Switch
                                                                            checked={data.manage_type}
                                                                            checkedChildren="Percentage"
                                                                            unCheckedChildren="Fixed Price"
                                                                            size='medium'
                                                                            disabled
                                                                            style={{ backgroundColor: data.manage_type ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                                            onChange={(e) => handleParkingUnit(e, index, 'manage_type')}
                                                                        />
                                                                    </Space>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }
                                                </div>
                                            ))
                                        }
                                        <Row>
                                            <Col span={12} className='mt-4 mb-4'>
                                                <Button
                                                    type='primary'
                                                    disabled
                                                    className='button-color btn-header'
                                                    onClick={handleAddRow}
                                                >
                                                    + Add Row
                                                </Button>
                                            </Col>  
                                            {
                                                parkingRow.length === 0 && (
                                                    <Col span={12} className='mt-4 tenants-terminated'>
                                                        *The Parking Details is Required
                                                    </Col> 
                                                )
                                            } 
                                        </Row>
                                    </>
                                )
                            }
                            {
                                type === 'unit' && (
                                    <>
                                        <Divider className='divider-text'>Authorizations</Divider>
                                        <Row>
                                            <Col span={24} className='p-2'>
                                                Authorized Signatories
                                            </Col>
                                        </Row>
                                        <Row className='responsive-overflow-y'>
                                            <Col span={24} className='p-2'>
                                                <AddRowTable
                                                    tableHeaders={[
                                                    "Name",
                                                    "Position",
                                                    ]}
                                                    headerSelector={[
                                                    "signatory_name",
                                                    "signatory_position",
                                                    ]}
                                                    withAction={true}
                                                    withRender={false}
                                                    withAddRow={true}
                                                    // isDisabled={true}
                                                    setDataSource={setAuthorizedSignatories}
                                                    dataSource={authorizedSignatories}
                                                    // inputDisabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24} className='p-2'>
                                                Local Authorized Representatives
                                            </Col>
                                        </Row>
                                        <Row className='responsive-overflow-y'> 
                                            <Col span={24} className='p-2'>
                                            
                                            <AddRowTable
                                                tableHeaders={[
                                                "Name",
                                                "Position",
                                                "Email",
                                                "Mobile Number",
                                                ]}
                                                headerSelector={[
                                                "representative_name",
                                                "representative_position",
                                                "representative_email",
                                                "representative_contact_no",
                                                ]}
                                                withAction={true}
                                                withRender={false}
                                                withAddRow={true}
                                                // isDisabled={true}
                                                setDataSource={setAuthorizedRepresentative}
                                                dataSource={authorizedRepresentative}
                                                // inputDisabled={true}
                                            />
                                        
                                            </Col>
                                        </Row>          
                                    </>
                                )
                            }         
                            <Row className='responsive-inline responsive-width mb-5 pb-5'>
                                <Col span={24} className='p-2'>
                                    <Item 
                                        label="Attachment"
                                        name="attachments" 
                                        // valuePropName="fileList" 
                                        getValueFromEvent={normFile} 
                                        noStyle
                                        >
                                        <Upload.Dragger 
                                            // disabled
                                            multiple
                                            name="files" 
                                            // action="/upload.do"
                                            fileList={attachmentsData}               
                                            beforeUpload={() => false}
                                            onRemove={handleDeleteAttachment}
                                        >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                        </Upload.Dragger>
                                    </Item>
                                </Col>
                            </Row>
                            <Row className=' mb-5'>
                                <Col span={24} className=''>
                                <Table 
                                    columns={columns2} 
                                    dataSource={newAttachment} 
                                    pagination={false}
                                    loading={{
                                    indicator: customSpinner, // Use custom spinner
                                    spinning: isLoading, // Set spinning based on loading state
                                    }}
                                />
                                </Col>
                            </Row>
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate(renew_form[type].cancel)}
                                        className='cancel-color btn-header'
                                    >
                                        Close
                                    </Button>
                                </Space>
                                <Col span={2} className='p-2'>
                                    <Button
                                        onClick={showSaveConfirm}
                                        loading={loading}
                                        type='primary'
                                        className='button-color btn-header'
                                    >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default RenewContracts
